import React from "react";
import { Card, Progress, Typography, Space } from "antd";
import { LineChartOutlined } from "@ant-design/icons";
import styled from "styled-components";

const { Text } = Typography;

const StyledCard = styled(Card)`
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  margin-bottom: 24px;
`;

const ProgressItem = styled.div`
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
`;

interface SubmissionProgressProps {
  submissionRate: number; // e.g. 95.8
  evaluationProgress: number; // e.g. 73.9
  submittedCount: number;
  totalStudents: number;
  gradedCount: number;
}

const SubmissionProgress: React.FC<SubmissionProgressProps> = ({
  submissionRate,
  evaluationProgress,
  submittedCount,
  totalStudents,
  gradedCount,
}) => {
  return (
    <StyledCard
      title={
        <Space>
          <LineChartOutlined style={{ color: "#1890ff" }} />
          <span>Submission Progress</span>
        </Space>
      }
    >
      <ProgressItem>
        <div className="d-flex justify-content-between mb-2">
          <Text strong>Submission Rate</Text>
          <Text strong style={{ color: "#1890ff" }}>
            {submissionRate}%
          </Text>
        </div>
        <Progress
          percent={submissionRate}
          strokeColor="#1890ff"
          showInfo={false}
          strokeWidth={10}
        />
        <Text
          type="secondary"
          style={{ fontSize: "12px", display: "block", marginTop: 4 }}
        >
          {submittedCount} OF {totalStudents} STUDENTS SUBMITTED
        </Text>
      </ProgressItem>

      <ProgressItem>
        <div className="d-flex justify-content-between mb-2">
          <Text strong>Evaluation Progress</Text>
          <Text strong style={{ color: "#52c41a" }}>
            {evaluationProgress}%
          </Text>
        </div>
        <Progress
          percent={evaluationProgress}
          strokeColor="#52c41a"
          showInfo={false}
          strokeWidth={10}
        />
        <Text
          type="secondary"
          style={{ fontSize: "12px", display: "block", marginTop: 4 }}
        >
          {gradedCount} OF {submittedCount} SUBMISSIONS GRADED
        </Text>
      </ProgressItem>
    </StyledCard>
  );
};

export default SubmissionProgress;
